// extracted by mini-css-extract-plugin
export var closeButton = "_ll-1";
export var closeX = "_ll-3";
export var container = "_ll-0";
export var image = "_ll-2";